import { AboutJsonBody } from "@/core/models/DashboardComponent.model";

/** Preserve existing language content when moving the old fields into Plate. */
export function getAboutEditorContent(data: AboutJsonBody | null, language: string): any[] {
  if (Array.isArray(data?.content) && data.content.length) {
    return data.content.map((node) => {
      // The initial Arabic import used fixed pixel sizes, unlike the editor's
      // responsive rem typography. Migrate only those original imported marks.
      if (!/^about-ar-\d+$/.test(node.id || "")) return node;
      return {
        ...node,
        children: node.children.map((leaf: any) => {
          if (leaf.fontSize !== "23px" && leaf.fontSize !== "28px") return leaf;
          const { fontSize, ...marks } = leaf;
          return marks;
        }),
      };
    });
  }
  const nodes: any[] = [];
  const add = (text: string | undefined, type = "p") => {
    if (text) nodes.push({ type, align: language === "ar" ? "right" : "left", children: [{ text }] });
  };
  for (const section of [data?.whoWeAre, data?.vision, data?.mission, data?.methodology]) {
    add(section?.title, "h2");
    if (section && "subtitle" in section && typeof section.subtitle === "string") add(section.subtitle);
    add(section?.description);
  }
  add(data?.strategicGoals?.title, "h2");
  for (const goal of data?.strategicGoals?.goals || []) {
    add(goal.title, "h3");
    add(goal.description);
  }
  return nodes.length ? nodes : [{ type: "p", children: [{ text: "" }] }];
}
